import type { StoreCameras } from '@gozoki/api-types'
import { removeTrailingSlash } from '@gozoki/tools'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

export interface AiVideoCamera {
  id: string
  label: string
}

export const fetchAiVideoCameras = async (storeId: string): Promise<AiVideoCamera[]> => {
  const id = Number.parseInt(storeId, 10)
  if (Number.isNaN(id)) {
    return []
  }
  try {
    const { data } = await gozokiApiWithAuth.get<StoreCameras>(`/stores/${id}/camera-ids`)
    return data.cameras.map((cam) => ({ id: String(cam.id), label: cam.label }))
  } catch (error) {
    console.error('fetchAiVideoCameras failed', error)
    return []
  }
}

// Conservé pour les consommateurs qui ne se servent que des ids (app mobile, etc.).
export const fetchAiVideoIds = async (storeId: string): Promise<string[]> => {
  const cameras = await fetchAiVideoCameras(storeId)
  return cameras.map((c) => c.id)
}

export const generateStreamUrl = (
  storeId?: string | null,
  videoId?: string | null,
): string | undefined => {
  const baseUrl = gozokiApi.defaults.baseURL
  if (!storeId || !videoId || !baseUrl) {
    return undefined
  }
  return `${removeTrailingSlash(baseUrl)}/stream-proxy/full/${storeId}/${videoId}/video.mjpeg`
}

export const generatePreviewStreamUrl = async (
  storeId?: string | null,
  videoId?: string | null,
) => {
  const baseUrl = gozokiApi.defaults.baseURL
  if (!storeId || !videoId || !baseUrl) {
    return null
  }
  return `${removeTrailingSlash(baseUrl)}/stream-proxy/preview/${storeId}/${videoId}/video.mjpeg`
}
